import React, {useEffect, useRef, useState} from 'react';
import {StyleSheet, Text, TouchableOpacity, View} from 'react-native';
import Colors from '../../../assets/Color/Colors';
import Width from '../../../assets/Width';
import {AnimatedCircularProgress} from 'react-native-circular-progress';
import {globalFontStyle, globalStyle} from '../../../assets';
import FastImage from '../../../common/FastImage';
import {greenTick, orangeComb, white_clock} from '../../../utils/images';
import {globalConst} from '../../../utils/globalConstant';
import {TimerApp} from '../../../commonComponents/timer';
import CommonModal from '../../../commonComponents/commonModal';
import RewardClaimBottomSheet from './claimBottomSheet';
import {Network} from '../../../utils/network';
import {TEST_API} from '../../../utils/apiUrl';
import {useDispatch, useSelector} from 'react-redux';
import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {getGamificationDetails} from '../redux/rewards.action';
import {getUser} from '../../Profile/redux/profile.action';
import { useToast } from '../../../components/core/Toast';

const Status = {
  COMPLETE: 'complete',
  ACTIVE: 'active',
};

const Gamification = () => {
  const rewardDetail = useSelector(
    ({rewardsReducer}) => rewardsReducer?.gamificationDetailData,
  );
  const isCompleted = rewardDetail?.status === Status.COMPLETE;
  const rewardData = isCompleted ? rewardDetail?.completion : rewardDetail;
  const [promoSuccessModal, setPromoSuccessModal] = useState(false);
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const { toast } = useToast();

  const onClaimClick = async () => {
    if (rewardData?.static?.cta) {
      navigation.navigate('RewardsStack', {screen: 'RewardsDetails', params: rewardData?.static});
    }
    else if (rewardData?.cta) {
      navigation.navigate('Profile');
    } else {
      const res = await Network.claimReward({}, true);
      if (res?.data?.success) {
        setPromoSuccessModal(res?.data);
      } else {
        toast({
          title: res?.data?.error,
          variant: 'destructive'
        });
      }
    }
  };

  const getReward = async () => {
    dispatch(getGamificationDetails());
  };

  useFocusEffect(
    React.useCallback(() => {
      getReward();
    }, []),
  );
  return (
    <>
      {rewardDetail?.success &&
      !rewardDetail?.flowComplete &&
      rewardDetail?.active ? (
        <View style={{marginTop: 10}}>
          <View
            style={[
              styles.outerBoxDesign,
              {
                backgroundColor: rewardData?.bgColor,
              },
            ]}>
            <View style={{flexDirection: 'row', flex: 1}}>
              <View>
                {isCompleted || rewardData?.cta || rewardData?.static ? (
                  <FastImage
                    style={{width: 45, height: 45}}
                    source={
                      isCompleted
                        ? greenTick()
                        : {uri: TEST_API + rewardData?.icon}
                    }
                  />
                ) : (
                  <AnimatedCircularProgress
                    size={45}
                    strokeWidth={12}
                    width={5}
                    style={{transform: [{scaleX: -1}]}}
                    fill={(rewardData?.progress / rewardData?.total) * 100}
                    rotation={0}
                    tintColor={Colors.bgWhite}
                    backgroundColor="rgba(0, 0, 0, 0.05)">
                    {fill => (
                      <Text
                        style={{
                          color: rewardData?.textColor,
                          transform: [{scaleX: -1}],
                          ...globalFontStyle.appFontSmallText,
                        }}>
                        {rewardData?.progress + '/' + rewardData?.total}
                      </Text>
                    )}
                  </AnimatedCircularProgress>
                )}
              </View>
              <View style={{marginLeft: 10, justifyContent: 'center', flex: 1}}>
                <Text
                  style={[
                    globalFontStyle.appFontHeading,
                    {color: rewardData?.textColor},
                  ]}>
                  {rewardData?.title}
                </Text>
                <View
                  style={{
                    flexDirection: 'row',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                  }}>
                  <Text
                    style={[
                      globalFontStyle.appFontSmallText,
                      {color: rewardData?.textColor, paddingRight: 2},
                    ]}
                    numberOfLines={2}>
                    {rewardData?.info}
                  </Text>
                  {isCompleted || rewardData?.cta
                    ? null
                    : Date.parse(rewardData?.exptime) - Date.now() >= 0 && (
                        <>
                          <FastImage
                            style={{width: 10, height: 10, paddingRight: 2}}
                            source={white_clock()}
                          />
                          <TimerApp
                            deadline={rewardData?.exptime}
                            timerExpireCallback={getReward}
                            customStyle={{
                              color: rewardData?.textColor,
                              ...globalFontStyle.appFontSmallTextBold,
                            }}
                          />
                        </>
                      )}
                </View>
              </View>
            </View>

            <View style={{position: 'absolute', right: 0, top: 0}}>
              <FastImage
                style={{width: 84, height: 70}}
                source={{
                  uri: TEST_API + rewardData?.img,
                }}
              />
            </View>
            {(isCompleted || rewardData?.cta || rewardData?.static?.cta) ? (
              <TouchableOpacity
                onPress={onClaimClick}
                style={styles.btnOuterCustomStyle}>
                <Text
                  style={{
                    ...globalFontStyle.appFontSmallText,
                    color: isCompleted ? Colors.green : Colors.black,
                  }}>
                  {rewardData?.cta ? rewardData?.cta
                    : rewardData?.static?.cta ? rewardData?.static?.cta
                    : "Claim Now"}
                </Text>
              </TouchableOpacity>
            ) : null}
          </View>
          <CommonModal
            onModalCallBack={() => {
              setPromoSuccessModal(false);
              getReward();
              dispatch(getUser());
            }}
            persistent={true}
            customModalStyle={[globalStyle.modalStyleCenter]}
            showModal={promoSuccessModal ? true : false}>
            <RewardClaimBottomSheet
              dataObj={promoSuccessModal}
              closeBottomSheet={() => {
                setPromoSuccessModal(false);
                getReward();
                dispatch(getUser());
              }}
            />
          </CommonModal>
        </View>
      ) : null}
    </>
  );
};
export default React.memo(Gamification);

const styles = StyleSheet.create({
  outerBoxDesign: {
    padding: 12,
    borderRadius: 8,
    borderWidth: 0.75,
    width: Width.width - 32,
    borderColor: Colors.borderColor,
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: 70,
    // flex: 1,
  },
  btnOuterCustomStyle: {
    paddingHorizontal: 5,
    paddingVertical: 5,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Colors.bgWhite,
    borderRadius: 8,
    height: 28,
    alignSelf: 'center',
  },
});
